var map = {
	"./About.vue": "a626",
	"./Areas.vue": "b9f7",
	"./Buildings.vue": "bbd2",
	"./Default.vue": "e576",
	"./Forbehold.vue": "c92e",
	"./Location.vue": "9303"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "97e7";